import { Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { InputDate } from "../../controls";
import ReactApexChart from "react-apexcharts";
import { getDaysByMonth } from "../../hooks/Method";
import moment from "moment";
import { useTranslation } from "react-i18next";

const MemberProfile = (props) => {
  const { t } = useTranslation();
  const [date, setDate] = useState(new Date());
  const [series, setSeries] = useState([]);

  const options = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        borderRadius: 3,
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        inverseColors: true,
        gradientToColors: ["#6078ea"],
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },

    noData: {
      text: `${t("Loading")}...`,
    },
    xaxis: {
      categories: getDaysByMonth(
        moment(new Date(date).toLocaleDateString(), "MM/DD/YYYY").format(
          "YYYY/MM"
        )
      ),
      legend: {
        position: "right",
        offsetY: 40,
      },
      fill: {
        opacity: 1,
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => val.toLocaleString() + " h",
        style: {
          fontSize: "14px",
        },
      },
    },
  };

  const handleInpChange = (newVal) => {
    setDate(newVal);
  };

  useEffect(() => {
    if (date) {
      setSeries([
        {
          name: t("Attendance"),
          data: [
            2.3, 3.1, 4.0, 4.1, 4.0, 3.6, 3.2, 2.3, 1.4, 4, 5, 0.2, 5, 2, 5, 2,
            1, 5, 4, 3, 1, 4, 4, 2.3, 3.1, 4.0, 4.1, 4.0, 3.6, 5,
          ],
        },
      ]);
    }

    return () => {
      setSeries([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  return (
    <Paper>
      <div className="p-10 d-flex flex-wrap j-between">
        <div>
          <h1 className="fs-20 fw-4 gray-color border-left mt-0 tx-upp">
            {t("Attendance")}
          </h1>
        </div>
        <div>
          <InputDate
            variant="outlined"
            sx={{ maxWidth: "200px" }}
            size="small"
            value={date}
            views={["month", "year"]}
            openTo="month"
            onChange={handleInpChange}
          />
        </div>
      </div>

      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        width="100%"
        height="300"
      />
    </Paper>
  );
};

export default MemberProfile;
